import { render, staticRenderFns } from "./cliente.direccion.update.vue?vue&type=template&id=9788032a&scoped=true&"
import script from "./cliente.direccion.update.vue?vue&type=script&lang=js&"
export * from "./cliente.direccion.update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9788032a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
